import styled from "styled-components"

const Paper = styled.div`
  background-color: ${(props) => props.theme.colours.paper};
  padding: 0.5rem;
  border-radius: ${(props) => props.theme.corners};
`
export default Paper
